module.exports = __webpack_public_path__ + "static/buyNowImg-2a8447de4b793f878fa1b347814eea86.png";